export function toCoordinatesQuery(selection: any) {
    return {
        geofenceGroups: (selection.geozoneGroups ?? [])
            .filter((g: any) => g?.groupId)
            .map((g: any) => ({
                groupGeofenceId: String(g.groupId),
                showAll: Boolean(g.showAll),
                geofenceIds: (g.geozoneIds ?? []).map((id: any) => String(id)),
            })),
        geofences: (selection.containersSites ?? [])
            .filter((z: any) => z?.geozoneId)
            .map((z: any) => ({
                geofenceId: String(z.geozoneId), // у тебя это geofenceId
                showAll: Boolean(z.showAll),
                containerPlatformsIds: (z.checkpointIds ?? []).map((id: any) => String(id)),
            })),
    };
}